<template lang="pug">
#outing-register(v-cloak)
  .box
    .box-header.with-border.register-header
      .title
        span 外出外泊届けの代理届け

    .box-body.register-body(v-if="_showInput")
      .note
        span.note-title ※代理届けは以下の点に注意してご使用ください
        b-card-text 
          ul.confirm-list
            li HitomeQ コネクト未登録ご家族の外出外泊届けの場合、案内の自動配信はありません。
      //- 利用者の選択
      FormInputSelect(
        key-name="利用者グループ"
        name="resident-group"
        v-model="residentGroupId"
        :options="residentGroupOptions"
        :styles="{ 'max-width': '540px' }")
      .d-flex.flex-row
        FormInputSelect(
          key-name="利用者"
          required
          name="resident"
          v-model="residentId"
          :options="_residentOptions"
          :validation-rules="{ required: true }"
          :styles="{ 'max-width': '340px' }"
          style="max-width: 360px")
          template(#optionText)
            .list-sort.d-flex.flex-row.align-items-center.mt-2(v-if="0 < _residentOptions.length" style="width: 100%;")
              span(style="font-weight: normal; font-size: 14px; min-width: 60px;") 並び順：
              b-form-select(v-model="residentSortCondition" :options="_residentSortOptions" size="sm")
        .mr-3
        .search-filter.d-flex.flex-column.align-self-end.mb-3
          .d-flex.flex-row.align-items-center(style="margin-top: 35px;")
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="residentSearchWord" type="search" placeholder="検索ワードを入力してください" 
                @input="changeResidentSearchWord" style="height: 42px;")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="search-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・利用者名
                div ・利用者名（ふりがな）
                div ・部屋名
      //- 申請者（家族）の登録状態
      InputOutingUseFamily(v-model="useFamily" :showRegisterd="showFamilyRegisterd")
      //- 家族が登録済みの場合、家族を選択させる
      .select-family(v-if="useFamily == true")
        FormInputSelect(v-model="familyId" name="family" key-name="申請者（家族）の選択"
          :options="_familyOptions" :validation-rules="{ required: true }" :styles="{ 'max-width': '540px' }" required)
      //- 家族が未登録の場合、直接入力させる
      .input-family(v-else)
        FormInput(v-model="familyName" name="family-name" key-name="申請者（氏名）"
          type="text" :maxlength="32" placeholder="申請者（氏名）"
          :validation-rules="{ required: true, max: 32 }" :styles="{ width: '340px' }" required)
        FormInput(v-model="familyRelation" name="family-relation" key-name="申請者（続柄）"
          type="text" :maxlength="10" placeholder="申請者（続柄）"
          :validation-rules="{ max: 10 }" :styles="{ width: '340px' }" required)
        FormInput(v-model="familyTel" name="family-tel" key-name="申請者（電話番号）"
          type="text" :maxlength="13" placeholder="申請者（電話番号）"
          :validation-rules="{ required: true, tel: true, max: 13 }" :styles="{ width: '340px' }" required)

      //- 届出種類
      .outing(v-if="residentId")
        FormInputRadio(v-model="type" name="type" key-name="届出種類"
          :options="_typeOptions" :validation-rules="{ required: true }" required)
        //- 外出日時
        .datetime(v-if="type == 'goingOut'")
          InputGoingOutDatetime(key-name="外出日時"
            :showYear="true"
            :year.sync="startYear" :years="_startYears"
            :month.sync="startMonth" :months="startMonths"
            :day.sync="startDay" :days="startDays"
            :startHour.sync="startHour" :startHours="startHours"
            :startMin.sync="startMin" :startMins="startMins"
            :endHour.sync="endHour" :endHours="endHours"
            :endMin.sync="endMin" :endMins="endMins"
            :realtimeError="outingDateErrorMessage1"
            validationDateKeyName="外出日時" required)
        .datetime(v-if="type == 'stayingOut'")
          InputStayingOutDatetime(key-name1="外泊開始日時" key-name2="外泊終了日時"
            :showYear="true"
            :year.sync="startYear" :years="_startYears"
            :month.sync="startMonth" :months="startMonths"
            :day.sync="startDay" :days="startDays"
            :startHour.sync="startHour" :startHours="startHours"
            :startMin.sync="startMin" :startMins="startMins"
            :stayCount.sync="stayingCount" :stayCounts="stayingCounts"
            :endHour.sync="endHour" :endHours="endHours"
            :endMin.sync="endMin" :endMins="endMins"
            :realtimeError1="outingDateErrorMessage1"
            :realtimeError2="outingDateErrorMessage2"
            validationDateKeyName="外出日時" required)
        //- 主な外出場所
        FormInput(v-model="location" name="location" key-name="主な外出場所" placeholder="利用者名"
          :maxlength="100" type="text" :validation-rules="{ required: true, max: 100 }" required)
        //- お迎えに来る方
        FormInputRadio(v-model="applicantPickup" name="applicant-pickup" key-name="お迎えに来る方"
          :options="_applicantPickupOptions" :validation-rules="{ required: true }" required)
        //- お迎えに来る方（自由記述）
        .pickup-person(v-if="applicantPickup == false")
          //- お迎えに来る方（氏名）
          FormInput(v-model="pickupPerson.name" name="pickup-person-name" key-name="お迎えに来る方（氏名）"
            type="text" placeholder="お迎えに来る方（氏名）" :maxlength="32" :validation-rules="{ required: true, max: 32 }"
            :styles="{ width: '340px' }" required)
          //- お迎えに来る方（続柄）
          FormInput(v-model="pickupPerson.relation" name="pickup-person-relation" key-name="お迎えに来る方（続柄）"
            type="text" placeholder="お迎えに来る方（続柄）" :maxlength="10" :validation-rules="{ required: true, max: 10 }"
            :styles="{ width: '340px' }" required)
        //- 外出手段
        FormInput(v-if="_showSelectedVehicle" v-model="selectedVehicle" name="selected-vehicle" key-name="外出手段" placeholder="外出手段"
          :maxlength="100" type="text" :validation-rules="{ required: true, max: 100 }" required)
        //- 施設での食事
        InputOutingNeedsMeal(v-if="_showOutingNeedsMeal" v-model="_inputOutingNeedsMealModel" :setting="setting")
        //- 同一利用者の家族に共有するか否か
        FormInputRadio(v-model="isSharedOuting" name="is-shared-outing" key-name="届出を他の同一利用者家族にも共有する"
          :options="_isSharedOutingOptions" :validation-rules="{ required: true }" required)
        //- 家族からの連絡事項
        FormTextarea(v-model="text" name="text" key-name="家族からの連絡事項"
          placeholder="例：家族からの連絡事項をご記載ください。"
          :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '640px', width: '640px', minHeight: '160px' }")
    .box-body.register-body(v-if="_showNotInput")
      span.error-message 外出外泊ともに受付停止中のため、代理届けはご利用できません。
      span.error-message ご利用になる場合は、外出外泊届けの基本設定で受付状態を受付中に変更してください。

    //- エラーメッセージ
    .register-row(v-show="errorMessage")
      .register-group
        .register-value
          .error-message {{ errorMessage }}

    .box-footer.register-footer
      ValidationAlert(v-model="showValidationAlert")
      .buttons.d-flex.flex-row.justify-content-end
        button.btn.edit-btn(v-if="_showInput" type="button" @click="onRegister") 登録
        button.btn.cancel-btn(type="button" @click="gotoOutingList") キャンセル

  //- 更新モーダル
  OkCancelModal(v-model="showRegisterConfirmModal" :title="registerConfirmModalTitle" @ok="registerOuting")
  OkModal(v-model="showRegisterSuccessModal" title="登録に成功しました。" @ok="gotoOutingList")

  //- 画面全体ローディング
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { PcUrl } from "@/commons/constants/PcUrl";
import { errorHandle } from "@/errorHandler";
import SystemError from "@/commons/models/SystemError";
import CustomValidate from "@/commons/utils/CustomValidate";

import ResidentsService, { ResidentGetModel } from "@/commons/services/Residents";
import FamiliesService, { FamilyGetModel, SenderType } from "@/commons/services/Families";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import OutingsService, { FamilyInfo, InputBy, NeedsMeal, OutingAvailableDatesGetModel, OutingPostModel, OutingType, TargetResidentInfo } from "@/commons/services/Outings";
import OutingSettingsService, { OutingSettingGetModel } from "@/commons/services/OutingSettings";

import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import FormInputRadio from "@/pc/components/forms/FormInputRadio.vue";
import FormDatetimePicker from "@/pc/components/forms/FormDatetimePicker.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import InputOutingUseFamily from "@/pc/components/outings/InputOutingUseFamily.vue";
import InputGoingOutDatetime from "@/pc/components/outings/InputGoingOutDatetime.vue";
import InputStayingOutDatetime from "@/pc/components/outings/InputStayingOutDatetime.vue";
import InputOutingNeedsMeal, { InputOutingNeedsMealModel } from "@/pc/components/outings/InputOutingNeedsMeal.vue";

@Component({
  components: {
    PageLoading,
    ValidationAlert,
    OkCancelModal,
    OkModal,
    HelpIcon,
    FormInputSelect,
    FormInputRadio,
    FormDatetimePicker,
    FormInput,
    FormTextarea,
    InputOutingUseFamily,
    InputGoingOutDatetime,
    InputStayingOutDatetime,
    InputOutingNeedsMeal
  },
  $_veeValidate: { validator: "new" }
})
export default class OutingRegister extends Vue {
  /** 利用者サービス */
  @Inject("ResidentsService") residentsService!: ResidentsService;
  /** 家族ユーザーサービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** 外出外泊サービス */
  @Inject("OutingsService") outingsService!: OutingsService;
  /** 外出外泊設定サービス */
  @Inject("OutingSettingsService") outingSettingsService!: OutingSettingsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** エラーメッセージ */
  errorMessage: string = "";
  /** 外出外泊届けエラーメッセージ */
  outingDateErrorMessage1: string = "";
  /** 外出外泊届けエラーメッセージ */
  outingDateErrorMessage2: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 外出外泊届け設定 */
  setting: OutingSettingGetModel | null = null;
  /** 外出外泊可能日時（開始） */
  outingAvailableStartDates: OutingAvailableDatesGetModel | null = null;
  /** 外出外泊可能日時（終了） */
  outingAvailableEndDates: OutingAvailableDatesGetModel | null = null;

  /**
   * 対象の利用者の入力情報
   */
  /** 利用者グループID */
  residentGroupId: number = 0;
  /** 利用者グループセレクトボックス用項目 */
  residentGroupOptions: Array<{ value: number | string; label: string }> = [];
  /** セレクトボックス用項目で使用する利用者 */
  residents: Array<ResidentGetModel> = [];
  /** 利用者ID */
  residentId: string | number = "";
  /** 利用者セレクトボックス用項目 */
  residentOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = [];
  /** 初期取得時の利用者セレクトボックス用項目 */
  sourceResidentOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = [];
  /** 利用者ソート条件 */
  residentSortCondition: ResidentSortCondition = ResidentSortCondition.NONE;
  /** 利用者検索ワード */
  residentSearchWord: string = "";

  /**
   * 届け出家族の登録状態
   * 登録されている場合は家族ID、登録されていない場合は直接入力させる
   */
  /** 届け出家族が登録されているか */
  useFamily: boolean = false;
  /** 家族の登録済みを表示するか否か */
  showFamilyRegisterd: boolean = true;
  /** 選択された利用者にひもづく家族 */
  families: Array<FamilyGetModel> = [];
  /** 家族登録済みの場合の選択した家族ID */
  familyId: number | null = null;
  /** 家族名 */
  familyName: string = "";
  /** 家族続柄 */
  familyRelation: string = "";
  /** 家族電話番号 */
  familyTel: string = "";

  /**
   * 外出外泊届けの入力情報
   */
  /** 外出、外泊種別 */
  type: OutingType | null = null;
  /** 入力者 */
  inputBy: InputBy = InputBy.FACILITY;

  /** 開始年 */
  startYear: string = "";
  /** 開始月 */
  startMonth: string = "";
  /** 開始月選択項目 */
  startMonths: Array<string> = [];
  /** 開始日 */
  startDay: string = "";
  /** 開始日選択項目 */
  startDays: Array<string> = [];
  /** 開始時 */
  startHour: string = "";
  /** 開始時選択項目 */
  startHours: Array<string> = [];
  /** 開始分 */
  startMin: string = "";
  /** 開始分選択項目 */
  startMins: Array<string> = [];
  /** 宿泊日数 */
  stayingCount: string = "";
  /** 宿泊日数の単位 */
  stayingCounts: Array<{ label: string; value: string }> = [];
  /** 終了時 */
  endHour: string = "";
  /** 終了時選択項目 */
  endHours: Array<string> = [];
  /** 終了分 */
  endMin: string = "";
  /** 終了分選択項目 */
  endMins: Array<string> = [];

  /** 主な外出場所（100文字） */
  location: string = "";
  /** お迎え。申請者本人（true）、申請者以外（false） */
  applicantPickup: boolean | null = null;
  /** お迎え（自由記述） */
  pickupPerson: FamilyInfo | null | undefined = {
    name: "",
    relation: "",
    tel: ""
  };
  /** 外出手段 */
  selectedVehicle: string = "";
  /** 外出外泊開始日の食事が必要かどうか */
  startDateNeedsMeal: NeedsMeal = {
    breakfast: true,
    lunch: true,
    snack: true,
    dinner: true
  };
  /** 外出外泊終了日の食事が必要かどうか */
  endDateNeedsMeal: NeedsMeal = {
    breakfast: true,
    lunch: true,
    snack: true,
    dinner: true
  };
  /** 同一利用者の家族に共有するか否か。v3.38.0以前はundefined */
  isSharedOuting: boolean = false;
  /** 連絡事項（1000文字） */
  text: string = "";

  /**
   * モーダル
   */
  /** 更新確認モーダル表示可否 */
  showRegisterConfirmModal: boolean = false;
  /** 更新確認モーダルタイトル */
  registerConfirmModalTitle: string = "";
  /** 更新完了モーダル表示可否 */
  showRegisterSuccessModal: boolean = false;

  get _showInput(): boolean {
    // 設定が未取得、または設定で外出・外泊共に使用不可の場合はfalse
    if (!this.setting) {
      return false;
    }
    if (!this.setting.canApplication.goingOut && !this.setting.canApplication.stayingOut) {
      return false;
    }
    return true;
  }
  get _showNotInput(): boolean {
    // 設定が未取得、または設定で外出・外泊共に使用不可の場合はfalse
    if (!this.setting) {
      return false;
    }
    if (!this.setting.canApplication.goingOut && !this.setting.canApplication.stayingOut) {
      return true;
    }
    return false;
  }
  /** ### 届出種類選択肢 */
  get _typeOptions(): Array<{ value: string; label: string }> {
    if (!this.setting) {
      return [];
    }
    // 外出・外泊両方が受付中
    if (this.setting.canApplication.goingOut && this.setting.canApplication.stayingOut) {
      return [
        { value: OutingType.GOING_OUT, label: "外出届け" },
        { value: OutingType.STAYING_OUT, label: "外泊届け" }
      ];
    }
    // 外出のみ受付中
    else if (this.setting.canApplication.goingOut && !this.setting.canApplication.stayingOut) {
      return [{ value: OutingType.GOING_OUT, label: "外出届け" }];
    }
    // 外泊のみ受付中
    else if (!this.setting.canApplication.goingOut && this.setting.canApplication.stayingOut) {
      return [{ value: OutingType.STAYING_OUT, label: "外泊届け" }];
    }
    return [];
  }
  /** ### 開始年の選択肢 */
  get _startYears(): Array<{ label: string; value: number }> {
    const years: Array<{ label: string; value: number }> = [];
    for (let i = 0; i < 2; i++) {
      const date: Date = new Date();
      date.setFullYear(date.getFullYear() + i);
      const intlOptions: Intl.DateTimeFormatOptions = { year: "numeric" };
      const jpYear: string = new Intl.DateTimeFormat("ja-JP-u-ca-japanese", intlOptions).format(date).slice(0, -1); // 年が重複するので最終文字だけ削除;
      years.push({ label: `${date.getFullYear()}（${jpYear}）`, value: date.getFullYear() });
    }
    return years;
  }
  /** ### お迎えに来る方選択肢 */
  get _applicantPickupOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: true, label: "申請者と同じ" },
      { value: false, label: "申請者以外" }
    ];
  }
  /** 外出手段を表示するか否か */
  get _showSelectedVehicle(): boolean {
    if (!this.setting) {
      return false;
    }
    return this.setting.useSelectedVehicle;
  }
  /** ### 食事キャンセル情報入力を表示するか否か */
  get _showOutingNeedsMeal(): boolean {
    if (!this.type || !this._inputedStartAndEndDatetime) {
      return false;
    } else {
      return true;
    }
  }
  get _inputedStartAndEndDatetime(): boolean {
    // 共通部分が入力されているかを判定
    const inputedDatetime =
      this.startYear != "" && this.startMonth != "" && this.startDay != "" && this.startHour != "" && this.startMin != "" && this.endHour != "" && this.endMin != "" ? true : false;
    // 外出の場合はそのまま返す
    if (this.type == OutingType.GOING_OUT) {
      return inputedDatetime;
    }
    // 外泊の場合は宿泊日数が入力さているかも合わせて返す
    else if (this.type == OutingType.STAYING_OUT) {
      return inputedDatetime && this.stayingCount != "";
    }
    return false;
  }
  /** ### 食事キャンセル情報 */
  get _inputOutingNeedsMealModel(): InputOutingNeedsMealModel {
    // 開始日時を作成する
    const startDate = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDay), 0, 0);
    const startDatetime = this.$dateUtil.convertDateToNumber(startDate, "yyyymmddhhMM00000");
    // 終了日時を作成する
    startDate.setDate(startDate.getDate() + Number(this.stayingCount)); // 開始日に宿泊数を加算
    startDate.setHours(Number(this.endHour)); // 終了時を設定
    startDate.setMinutes(Number(this.endMin)); // 終了分を設定
    const endDatetime = this.$dateUtil.convertDateToNumber(startDate, "yyyymmddhhMM00000");
    return {
      /** 外出外泊種別 */
      type: this.type as OutingType,
      /** 開始日時 */
      startDatetime,
      /** 開始日時の食事情報 */
      startDateNeedsMeal: this.startDateNeedsMeal,
      /** 終了日時 */
      endDatetime,
      /** 終了日時の食事情報 */
      endDateNeedsMeal: this.endDateNeedsMeal
    } as any;
  }

  /** 同一利用者の家族に共有するか否か。v3.38.0以前はundefined */
  get _isSharedOutingOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: true, label: "はい" },
      { value: false, label: "いいえ" }
    ];
  }

  /**
   * ### 利用者グループIDの値更新を監視する
   *
   * - 利用者IDをリセットする
   * - 利用者のセレクトボックス選択項目を更新する
   */
  @Watch("residentGroupId")
  public changeResidentGroupId(newValue: number): void {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const residentOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = this.createResidentOptions(this.residents, newValue);
    this.residentId = "";
    this.sourceResidentOptions = residentOptions;
    this.changeResidentSearchWord();

    this.isBusy = false;

    return;
  }

  /**
   * ### 利用者ソート条件の値更新を監視する
   */
  @Watch("residentSortCondition")
  public changeResidentSortCondition(): void {
    this.sourceResidentOptions = this.createResidentOptions(this.residents, this.residentGroupId);
    this.changeResidentSearchWord();
  }

  get _residentSortOptions(): Array<{ value: ResidentSortCondition; text: string }> {
    return [
      { value: ResidentSortCondition.ROOM_NAME_ASC, text: "部屋名順" },
      { value: ResidentSortCondition.NAME_ASC, text: "利用者名順" }
    ];
  }

  get _residentOptions() {
    return this.residentOptions;
  }

  /**
   * ### 利用者IDの値更新を監視する
   *
   * - 登録済み家族かをリセットする
   * - 未登録家族の情報（氏名、続柄、電話番号）をリセットする
   * - 種別をリセットする
   *   - 設定で種別が1つしか選択できない場合は固定値にする
   * - 届け出日時（開始）と届け出日時（終了）をリセットする
   * - 届け出日時のエラーメッセージをリセットする
   * - 利用者IDが空文字なら処理終了
   * - 利用者が空文字以外なら保持するグループIDを取得する
   * - 登録種別が「登録済の家族」であれば家族ユーザーの選択肢を更新する
   */
  @Watch("residentId")
  public async changeResidentId(newValue: any | number): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    if (!this.setting) {
      return;
    }

    try {
      this.familyName = "";
      this.familyRelation = "";
      this.familyTel = "";
      this.initializeOutingByetting(this.setting as OutingSettingGetModel);
      this.startYear = "";
      this.startMonth = "";
      this.startDay = "";
      this.startHour = "";
      this.startMin = "";
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      if (!newValue) {
        return;
      }

      const families: Array<FamilyGetModel> = await this.getFamilies(newValue);
      this.families = families;
      this.familyId = null;

      if (this._familyOptions.length < 1) {
        this.showFamilyRegisterd = false;
      } else {
        this.showFamilyRegisterd = true;
      }
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 種別の値更新を監視する
   *
   * - 届け出日時（開始）と届け出日時（終了）をリセットする
   * - 届け出日時のエラーメッセージをリセットする
   */
  @Watch("type")
  public async changeType(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.startYear = "";
      this.startMonth = "";
      this.startDay = "";
      this.startHour = "";
      this.startMin = "";
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessage1 = "";
      this.outingDateErrorMessage2 = "";
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 開始年の値更新を監視する
   *
   * - 月以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 開始月のセレクトボックスの選択肢を更新する
   */
  @Watch("startYear")
  public changeStartYear(newValue: string): void {
    this.startMonth = "";
    this.startDay = "";
    this.startHour = "";
    this.startMin = "";
    this.stayingCount = "";
    this.endHour = "";
    this.endMin = "";

    this.outingDateErrorMessage1 = "";
    this.outingDateErrorMessage2 = "";

    const startMonths: Array<string> = this.createStartMonths(Number(newValue));
    this.startMonths = startMonths;

    if (startMonths.length == 0) {
      this.outingDateErrorMessage1 = "選択した年は外出外泊届けが出来ません。他の年を選択してください。";
    }

    return;
  }

  /**
   * ### 開始月選択肢を作成する
   */
  public createStartMonths(year: number): Array<string> {
    const date: Date = new Date();
    const currentYear: number = date.getFullYear();
    const currentMonth: number = date.getMonth();
    const months: Array<string> = [];

    for (let i = 0; i < 12; i++) {
      if (currentYear == year && currentMonth <= i) {
        months.push(String(i + 1));
      } else if (currentYear < year) {
        months.push(String(i + 1));
      }
    }

    return months;
  }

  /**
   * ### 開始月の値更新を監視する
   *
   * - 開始日以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 開始日のセレクトボックスの選択肢を更新する
   */
  @Watch("startMonth")
  public async changeStartMonth(newValue: string): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.startDay = "";
      this.startHour = "";
      this.startMin = "";
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessage1 = "";
      this.outingDateErrorMessage2 = "";

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const startDays: Array<string> = await this.createStartDays(Number(this.startYear), Number(newValue));
      this.startDays = startDays;

      if (startDays.length == 0) {
        this.outingDateErrorMessage1 = "選択した月は外出外泊届けが出来ません。他の月を選択してください。";
      }
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }
    return;
  }

  /**
   * ### 開始日付選択肢を作成する
   */
  public async createStartDays(year: number, month: number): Promise<Array<string>> {
    if (!this.setting) {
      return [];
    }

    const outingAvailableStartDates = await this.getAvailableStartDates(year, month);
    const days: Array<string> = [];
    for (const availableDate in outingAvailableStartDates) {
      const slicedAvailableDate = availableDate.slice(6, 9);
      // 0埋めされているので、数値にしてから文字列に戻す
      days.push(Number(slicedAvailableDate).toString());
    }
    this.outingAvailableStartDates = outingAvailableStartDates;

    return days;
  }

  public async getAvailableStartDates(year: number, month: number): Promise<OutingAvailableDatesGetModel> {
    const params: { type: string; residentId: number; year: number; month: number } = {
      type: this.type as OutingType,
      residentId: Number(this.residentId),
      year: year,
      month: month
    };
    const response: OutingAvailableDatesGetModel = await this.outingsService.getAvailableStartDates(userStore, params);
    return response;
  }

  /**
   * ### 開始日の値更新を監視する
   *
   * - 開始時以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 開始時のセレクトボックスの選択肢を更新する
   */
  @Watch("startDay")
  public changeStartDay(newValue: string): void {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.startHour = "";
      this.startMin = "";
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessage1 = "";
      this.outingDateErrorMessage2 = "";

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const startHours: Array<string> = this.createStartHours(Number(newValue));
      this.startHours = startHours;

      if (startHours.length == 0) {
        this.outingDateErrorMessage1 = "選択した日は外出外泊届けが出来ません。他の日を選択してください。";
      }
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }
    return;
  }

  /**
   * ### 開始時間選択肢を作成する
   */
  public createStartHours(day: number): Array<string> {
    if (!this.setting || !this.outingAvailableStartDates) {
      return [];
    }

    const hours: Array<string> = [];
    for (const availableDate in this.outingAvailableStartDates) {
      const slicedAvailableDate = availableDate.slice(6, 9);
      if (Number(slicedAvailableDate) == day) {
        for (const availableHour in this.outingAvailableStartDates[availableDate]) {
          hours.push(availableHour);
        }
      }
    }

    return hours;
  }

  /**
   * ### 開始時の値更新を監視する
   *
   * - 開始分以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 分のセレクトボックスの選択肢を更新する
   */
  @Watch("startHour")
  public changeStartHour(newValue: string): void {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.startMin = "";
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessage1 = "";
      this.outingDateErrorMessage2 = "";

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const startMins: Array<string> = this.createStartMins(Number(this.startDay), Number(newValue));
      this.startMins = startMins;

      if (startMins.length == 0) {
        this.outingDateErrorMessage1 = "選択した開始時は外出外泊届けが出来ません。他の開始時を選択してください。";
      }
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 開始分選択肢を作成する
   */
  public createStartMins(day: number, hour: number) {
    if (!this.setting || !this.outingAvailableStartDates) {
      return [];
    }

    for (const availableDate in this.outingAvailableStartDates) {
      const slicedAvailableDate = availableDate.slice(6, 9);
      if (Number(slicedAvailableDate) == day) {
        for (const availableHour in this.outingAvailableStartDates[availableDate]) {
          if (Number(availableHour) == hour) {
            return this.outingAvailableStartDates[availableDate][availableHour];
          }
        }
      }
    }

    return [];
  }

  /**
   * ### 開始分の値更新を監視する
   *
   * - 宿泊数以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 外出の場合は終了日、外泊の場合は宿泊数のセレクトボックスの選択肢を更新する
   */
  @Watch("startMin")
  public async changeStartMin(newValue: string): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.stayingCount = "";
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessage1 = "";
      this.outingDateErrorMessage2 = "";

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      // 外出の場合は終了日の選択肢を更新する
      if (this.type == OutingType.GOING_OUT) {
        const endHours: Array<string> = await this.createEndHours();
        this.endHours = endHours;

        if (endHours.length == 0) {
          this.outingDateErrorMessage1 = "選択した開始分は外出外泊届けが出来ません。他の開始分を選択してください。";
        }
      }
      // 外泊の場合は宿泊数の選択肢を更新する
      else if (this.type == OutingType.STAYING_OUT) {
        const startDatetime = this.$dateUtil.convertDateToNumber(
          new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDay), Number(this.startHour), Number(this.startMin)),
          "yyyymmdd000000000"
        );
        const stayingCounts: Array<{ label: string; value: string }> = await this.createStayingCounts(startDatetime);
        this.stayingCounts = stayingCounts;

        if (stayingCounts.length == 0) {
          this.outingDateErrorMessage2 = "選択した開始分は外出外泊届けが出来ません。他の開始分を選択してください。";
        }
      }
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 宿泊日数選択肢を作成する
   */
  private async createStayingCounts(startDatetime: number): Promise<Array<{ label: string; value: string }>> {
    if (!this.setting || !this.outingAvailableStartDates) {
      return [];
    }

    const outingAvailableEndDates = await this.getAvailableEndDates(startDatetime);
    const options: Array<{ label: string; value: string }> = [];
    const startDate = this.$dateUtil.convertNumberToDate(startDatetime);
    for (const availableDate in outingAvailableEndDates) {
      const currentDate = this.$dateUtil.convertNumberToDate(Number(`${availableDate}000000000`));
      const stayCount = this.$dateUtil.diffDate(startDate, currentDate);
      options.push({
        label: `${stayCount}泊（${this.$dateUtil.convertNumberToString(Number(`${availableDate}000000000`), "yyyy年mm月dd日")}）`,
        value: String(stayCount)
      });
    }
    this.outingAvailableEndDates = outingAvailableEndDates;

    return options;
  }

  public async getAvailableEndDates(datetime: number): Promise<OutingAvailableDatesGetModel> {
    const params: { type: string; residentId: number; datetime: string } = {
      type: this.type as OutingType,
      residentId: Number(this.residentId),
      datetime: this.$dateUtil.convertNumberToString(datetime, "yyyymmddhhMM")
    };
    const response: OutingAvailableDatesGetModel = await this.outingsService.getAvailableEndDates(userStore, params);
    return response;
  }

  /**
   * ### 終了時間選択肢を作成する
   */
  public async createEndHours(): Promise<Array<string>> {
    if (!this.setting || !this.outingAvailableStartDates) {
      return [];
    }

    // 選択肢作成対象の日付を作成する
    // 更に外出の場合、終了時間選択肢の情報を取得する必要がある（外泊の場合は宿泊日数選択肢の作成時に取得しているので取得不要）
    let day = null;
    if (this.type == OutingType.GOING_OUT) {
      const startDate = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDay), Number(this.startHour), Number(this.startMin));
      const startDatetime = this.$dateUtil.convertDateToNumber(startDate, "yyyymmddhhMM00000");
      const outingAvailableEndDates = await this.getAvailableEndDates(startDatetime);
      this.outingAvailableEndDates = outingAvailableEndDates;

      day = this.$dateUtil.convertDateToString(startDate, "yyyymmdd");
    } else if (this.type == OutingType.STAYING_OUT) {
      const startDate = new Date(
        Number(this.startYear),
        Number(this.startMonth) - 1,
        Number(this.startDay) + Number(this.stayingCount),
        Number(this.startHour),
        Number(this.startMin)
      );
      day = this.$dateUtil.convertDateToString(startDate, "yyyymmdd");
      await this.$timerUtil.setTimeout(1); // asyncのfunctionでawaitしないと描画が止まる問題があるので1msawaitする
    } else {
      return [];
    }

    const hours: Array<string> = [];
    for (const availableDate in this.outingAvailableEndDates) {
      if (availableDate == day) {
        for (const availableHour in this.outingAvailableEndDates[availableDate]) {
          hours.push(availableHour);
        }
      }
    }

    return hours;
  }

  /**
   * ### 宿泊数の値更新を監視する
   *
   * - 終了時以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 終了時のセレクトボックスの選択肢を更新する
   */
  @Watch("stayingCount")
  public async changeStayingCounts(newValue: string): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.endHour = "";
      this.endMin = "";

      this.outingDateErrorMessage1 = "";
      this.outingDateErrorMessage2 = "";

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const endHours: Array<string> = await this.createEndHours();
      this.endHours = endHours;

      if (endHours.length == 0) {
        this.outingDateErrorMessage2 = "選択した宿泊数は外出外泊届けが出来ません。他の宿泊数を選択してください。";
      }
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 終了時の値更新を監視する
   *
   * - 終了分以降の入力値をリセットする
   * - エラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 終了分のセレクトボックスの選択肢を更新する
   */
  @Watch("endHour")
  public changeEndHour(newValue: string): void {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.endMin = "";

      this.outingDateErrorMessage1 = "";
      this.outingDateErrorMessage2 = "";

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const endMins: Array<string> = this.createEndMins(newValue);
      this.endMins = endMins;

      if (endMins.length == 0) {
        // 外出
        if (this.type == OutingType.GOING_OUT) {
          this.outingDateErrorMessage1 = "選択した終了時は外出外泊届けが出来ません。他の終了時を選択してください。";
        }
        // 外泊
        else if (this.type == OutingType.STAYING_OUT) {
          this.outingDateErrorMessage2 = "選択した終了時は外出外泊届けが出来ません。他の終了時を選択してください。";
        }
      }
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 終了分選択肢を作成する
   */
  public createEndMins(hour: string) {
    if (!this.setting || !this.outingAvailableStartDates || !this.outingAvailableEndDates) {
      return [];
    }

    const startDate = new Date(
      Number(this.startYear),
      Number(this.startMonth) - 1,
      Number(this.startDay) + Number(this.stayingCount),
      Number(this.startHour),
      Number(this.startMin)
    );
    const day = this.$dateUtil.convertDateToString(startDate, "yyyymmdd");

    for (const availableDate in this.outingAvailableEndDates) {
      if (availableDate == day) {
        for (const availableHour in this.outingAvailableEndDates[availableDate]) {
          if (availableHour == hour) {
            return this.outingAvailableEndDates[availableDate][availableHour];
          }
        }
      }
    }

    return [];
  }

  /**
   * ### 利用者にひもづく家族を取得する
   */
  public async getFamilies(residentId: number): Promise<Array<FamilyGetModel>> {
    const response: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, residentId);
    return response;
  }

  get _familyOptions(): Array<{ value: number | string; label: string }> {
    const familyOptions: Array<{ value: number; label: string }> = [];
    for (const family of this.families) {
      let label: string = `${family.familyName}`;

      // 続柄・役割を付与する
      if (family.familyRelation && family.familyPosition) {
        label += `（${family.familyRelation}・${family.familyPosition}）`;
      }
      // 続柄のみ
      else if (family.familyRelation) {
        label += `（${family.familyRelation}）`;
      }
      // 役割のみ
      else if (family.familyPosition) {
        label += `（${family.familyPosition}）`;
      }

      // メールユーザーの場合、メールユーザーであることを付与する
      if (family.senderType == SenderType.MAIL) {
        label += "（メール）";
      }

      familyOptions.push({
        value: family.familyId,
        label: label
      });
    }
    return familyOptions;
  }

  /**
   * ### vue lifecycle created
   */
  public created(): void {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const residents: Array<ResidentGetModel> = await this.getResidents();
    const residentOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = this.createResidentOptions(residents, this.residentGroupId);
    this.residents = residents;
    this.residentOptions = residentOptions;
    this.sourceResidentOptions = this.createResidentOptions(residents, this.residentGroupId);

    const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const residentGroupOptions: Array<{ value: number; label: string }> = this.createResidentGroupOptions(residentGroups, residents);
    this.residentGroupId = 0;
    this.residentGroupOptions = residentGroupOptions;

    const setting: OutingSettingGetModel = await this.getOutingSetting();
    this.setting = setting;

    this.initializeOutingByetting(setting);

    this.isBusy = false;
    return;
  }

  /**
   * ### 利用者取得
   */
  public async getResidents(): Promise<Array<ResidentGetModel>> {
    let response: Array<ResidentGetModel> = [];

    try {
      response = await this.residentsService.gets(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.residentsService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number } = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.residentsService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 利用者セレクトボックス用項目を作成する
   *
   * - 渡されたグループIDを持つ利用者のみを項目にする
   * - 渡されたグループIDが0(全て)の場合は全利用者を項目にする
   * - 選択肢の表示項目名は 利用者名（利用者部屋名）
   */
  public createResidentOptions(residents: Array<ResidentGetModel>, groupId: number): Array<{ value: number; label: string; kanaName: string | undefined }> {
    // ソート条件があればソートする
    const _residents = residents.concat().sort((a, b) => {
      switch (this.residentSortCondition) {
        // 部屋名昇順
        case ResidentSortCondition.ROOM_NAME_ASC:
          return a.room.localeCompare(b.room, "ja");
        // 利用者名昇順
        case ResidentSortCondition.NAME_ASC: {
          // ふりがなが両方存在する場合はふりがなで比較
          if (a.kanaName && b.kanaName) {
            return a.kanaName.localeCompare(b.kanaName, "ja");
          }
          // ふりがなが存在する方を優先
          if (a.kanaName && !b.kanaName) return -1;
          if (!a.kanaName && b.kanaName) return 1;

          // ふりがなが無いもの同士は漢字名で比較
          return a.name.localeCompare(b.name, "ja");
        }
        default:
          return 0;
      }
    });

    const options: Array<{ value: number; label: string; kanaName: string | undefined }> = [];
    for (const resident of _residents) {
      if (resident.groupId == groupId || groupId == 0) {
        options.push({
          value: resident.id,
          label: `${resident.name}（${resident.room}）`,
          kanaName: resident.kanaName
        });
      }
    }
    return options;
  }

  /**
   * ### 利用者グループ取得
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者グループセレクトボックス用項目を作成する
   *
   * - 利用者グループに「全て」を追加する
   * - 全て以外は渡された利用者グループで項目を作成する
   *   - ユーザーの権限を見て、閲覧できない権限の利用者グループは選択肢にしない
   *   - 利用者が一人もいない利用者グループは選択肢にしない
   */
  public createResidentGroupOptions(residentGroups: Array<ResidentGroupsGetModel>, residents: Array<ResidentGetModel>): Array<{ value: number; label: string }> {
    const options: Array<{ value: number; label: string }> = [];

    options.push({
      value: 0,
      label: `全て`
    });

    const canUseResidentGroupMap: Map<number, number> = new Map<number, number>();
    for (const resident of residents) {
      canUseResidentGroupMap.set(resident.groupId, resident.groupId);
    }
    const allowedGroupsMap: Map<number, number> = new Map<number, number>();
    for (const allowedGroup of userStore.loginUser.permissions.residentGroups) {
      allowedGroupsMap.set(allowedGroup, allowedGroup);
    }
    for (const group of residentGroups) {
      if (canUseResidentGroupMap.has(group.id) && allowedGroupsMap.has(group.id)) {
        options.push({
          value: group.id,
          label: `${group.name}`
        });
      }
    }

    return options;
  }

  /**
   * ### 外出外泊届け設定取得
   */
  public async getOutingSetting(): Promise<OutingSettingGetModel> {
    const response: OutingSettingGetModel = await this.outingSettingsService.get(userStore);
    return response;
  }

  /**
   * ### 入力要素の初期化
   *
   * - 設定により入力制限があるもので、固定値にするものがあるのでここで設定する
   */
  public initializeOutingByetting(setting: OutingSettingGetModel): void {
    if (!this.setting) {
      this.type = null;
      return;
    }
    // 外出・外泊両方が受付中
    if (this.setting.canApplication.goingOut && this.setting.canApplication.stayingOut) {
      this.type = null;
    }
    // 外出のみ受付中
    else if (this.setting.canApplication.goingOut && !this.setting.canApplication.stayingOut) {
      this.type = OutingType.GOING_OUT;
    }
    // 外泊のみ受付中
    else if (!this.setting.canApplication.goingOut && this.setting.canApplication.stayingOut) {
      this.type = OutingType.STAYING_OUT;
    }

    // 設定によっては非表示になる項目は強制的に食事しないに設定したいため施設での食事を初期化する
    this.startDateNeedsMeal = this.initializeDateNeedsMealBySetting(this.startDateNeedsMeal, setting);
    this.endDateNeedsMeal = this.initializeDateNeedsMealBySetting(this.endDateNeedsMeal, setting);

    return;
  }

  /** ### 設定の「食事の使用有無」で「使用しない」ものは強制的に食事しないに更新する */
  initializeDateNeedsMealBySetting(needsMeal: NeedsMeal, setting: OutingSettingGetModel): NeedsMeal {
    if (setting.useNeedsMeal.breakfast == false) {
      needsMeal.breakfast = false;
    }
    if (setting.useNeedsMeal.lunch == false) {
      needsMeal.lunch = false;
    }
    if (setting.useNeedsMeal.snack == false) {
      needsMeal.snack = false;
    }
    if (setting.useNeedsMeal.dinner == false) {
      needsMeal.dinner = false;
    }
    return needsMeal;
  }

  /**
   * ### 利用者検索ワードによるフィルタリング
   */
  public changeResidentSearchWord(): void {
    const filterdOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = this.sourceResidentOptions.concat().filter((option) => {
      if (!this.residentSearchWord) {
        return true;
      }

      const existWordFromLabel = 0 <= option.label.indexOf(this.residentSearchWord) ? true : false;
      const existWordFromKanaName = option.kanaName && 0 <= option.kanaName.indexOf(this.residentSearchWord) ? true : false;
      const existWord: boolean = existWordFromLabel || existWordFromKanaName;
      if (option.value == this.residentId && !existWord) {
        this.residentId = "";
      }
      return existWord;
    });
    this.residentOptions = filterdOptions;
    return;
  }

  /**
   * ### 外出外泊届け更新確認モーダルを表示する
   */
  public async onRegister(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      const typeName: string = this.type == OutingType.GOING_OUT ? "外出" : this.type == OutingType.STAYING_OUT ? "外泊" : "";
      this.registerConfirmModalTitle = `${typeName}届けを登録しますか？`;
      this.showRegisterConfirmModal = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ## 外出外泊届けを登録する
   */
  public async registerOuting(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中...";

    const requestBody: OutingPostModel = await this.createRequestBody();
    await this.outingsService.post(userStore, requestBody);

    this.isBusy = false;
    this.showRegisterSuccessModal = true;

    return;
  }

  /**
   * ### 外出外泊届け登録パラメータ作成
   */
  public createRequestBody(): OutingPostModel {
    const requestBody: OutingPostModel = {
      /** 外出、外泊種別 */
      type: this.type as OutingType,
      /** 入力者 */
      inputBy: this.inputBy as InputBy,
      /** 外出外泊開始日時 */
      startDatetime: this.createRequestStartDatetime(),
      /** 外出外泊終了日時 */
      endDatetime: this.createRequestEndDatetime(),
      /** 申請者家族を一意に特定するキー（residentsTBLのresidentsSortKey） */
      residentsSortKey: this.createResidentsSortKey(),
      /** 外出外泊対象の利用者の申請時の情報 */
      targetResidentInfo: this.createTargetResidentInfo(),
      /** 申請した家族の申請時の情報 */
      applicantFamilyInfo: this.createApplicantFamilyInfo(),
      /** 主な外出場所（100文字） */
      location: this.location,
      /** お迎え。申請者本人（true）、申請者以外（false） */
      applicantPickup: this.applicantPickup as boolean,
      /** お迎え（自由記述） */
      pickupPerson: this.applicantPickup ? null : this.pickupPerson,
      /** 外出手段 */
      selectedVehicle: this.selectedVehicle,
      /** 外出外泊開始日の食事が必要かどうか */
      startDateNeedsMeal: this.startDateNeedsMeal,
      /** 外出外泊終了日の食事が必要かどうか */
      endDateNeedsMeal: this.type == OutingType.GOING_OUT ? null : this.type == OutingType.STAYING_OUT ? this.endDateNeedsMeal : null,
      /** 同一利用者の家族に共有するか否か。v3.38.0以前はundefined */
      isSharedOuting: this.isSharedOuting,
      /** 連絡事項（1000文字） */
      text: this.text ? this.text : ""
    };
    return requestBody;
  }

  /**
   * ### リクエスト用の開始日時を作成する
   */
  public createRequestStartDatetime(): number {
    const date = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDay), Number(this.startHour), Number(this.startMin));
    return this.$dateUtil.convertDateToNumber(date, "yyyymmddhhMM00000");
  }

  /**
   * ### リクエスト用の終了日時を作成する
   */
  public createRequestEndDatetime(): number {
    // 外出
    if (this.type == OutingType.GOING_OUT) {
      const date = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDay), Number(this.endHour), Number(this.endMin));
      return this.$dateUtil.convertDateToNumber(date, "yyyymmddhhMM00000");
    }
    // 外泊
    else if (this.type == OutingType.STAYING_OUT) {
      const date = new Date(Number(this.startYear), Number(this.startMonth) - 1, Number(this.startDay), Number(this.endHour), Number(this.endMin));
      date.setDate(date.getDate() + Number(this.stayingCount));
      return this.$dateUtil.convertDateToNumber(date, "yyyymmddhhMM00000");
    }
    return 0;
  }

  /**
   * ### リクエスト用の申請者家族ソートキーを作成する
   *
   * - 登録済み家族の場合、家族のソートキー
   * - 未登録家族の場合、利用者のソートキー
   */
  public createResidentsSortKey(): string {
    // 登録済み家族
    if (this.useFamily) {
      return `${this.residentId}_${this.familyId}`;
    }
    // 未登録家族
    else {
      return `${this.residentId}_0`;
    }
  }

  public createTargetResidentInfo(): TargetResidentInfo {
    let targetResident = null;
    for (const resident of this.residents) {
      if (resident.id == this.residentId) {
        targetResident = resident;
      }
    }
    if (!targetResident) {
      throw new SystemError("利用者が選択されていません");
    } else {
      return {
        name: targetResident.name,
        kanaName: targetResident.kanaName ? targetResident.kanaName : "",
        groupId: targetResident.groupId,
        roomId: targetResident.roomId,
        roomName: targetResident.room
      };
    }
  }

  public createApplicantFamilyInfo(): FamilyInfo {
    // 登録済み家族
    if (this.familyId) {
      let targetFamily = null;
      for (const family of this.families) {
        if (family.familyId == this.familyId) {
          targetFamily = family;
        }
      }
      if (!targetFamily) {
        throw new SystemError("家族が選択されていません");
      } else {
        return {
          name: targetFamily.familyName,
          relation: targetFamily.familyRelation,
          tel: targetFamily.familyTel
        };
      }
    }
    // 未登録家族
    else {
      return {
        name: this.familyName,
        relation: this.familyRelation,
        tel: this.familyTel ? this.familyTel : ""
      };
    }
  }

  /**
   * ### 外出外泊届け一覧画面へ遷移する
   */
  public gotoOutingList(): void {
    this.$router.push(PcUrl.OutingList);
    return;
  }
}

enum ResidentSortCondition {
  /** 未選択 */
  NONE = "",
  /** ID昇順 */
  ROOM_NAME_ASC = "roomNameAsc",
  /** 利用者名昇順 */
  NAME_ASC = "nameAsc"
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

#outing-register {
  max-width: 840px;
  margin-left: auto;
  margin-right: auto;

  .search-filter {
    .search-filter-input-group {
      width: 310px;
      min-width: 310px;

      .search-filter-icon {
        background-color: #fff !important;
        .search-icon {
          @include svg-icon("../../../assets/search.svg", $font-base-color, 20px, 20px);
        }
      }
      .search-filter-input {
        border-left: 0;
      }
    }
  }

  .edit-btn,
  .cancel-btn {
    width: 120px;
  }
}
</style>
